var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "setting-field",
      class: { "disable-html-component": _vm.missing },
    },
    [
      _c(
        "el-badge",
        {
          staticClass: "label",
          attrs: { value: "error", hidden: !_vm.missing },
        },
        [_c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")])]
      ),
      _vm._v(" "),
      _c("el-switch", {
        attrs: { disabled: _vm.disabled },
        on: { change: _vm.onChange },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.value ? "on" : "off"))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }